<template>
  <card class="card-user">
    <img slot="image" v-bind:src="require('../../assets/images/insurtech_logo.png')" style="width:37%;margin-top:18px" alt="..."/>
    <div class="author">
      <a href="#">
        <img class="avatar border-gray" :src="require('../../assets/images/jacob-ellenhard_h.jpg.webp')" style="margin-top: 21px;height: 136px;"  alt="..."/>

        <h4 class="title" style="margin:12px">Jacob Ellenhard<br />
          <small>CEO / Managing Partner / Insurance Broker</small>
        </h4>
      </a>
    </div>
    <p class="description text-center"> +45 8172 0202 <br>
        jel@ensurecph.dk
    </p>
  
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  export default {
    components: {
      Card
    },
    data () {
      return {
        details: [
          {
            title: '12',
            subTitle: 'Files'
          },
          {
            title: '2GB',
            subTitle: 'Used'
          },
          {
            title: '24,6$',
            subTitle: 'Spent'
          }
        ]
      }
    },
    methods: {
      getClasses (index) {
        var remainder = index % 3
        if (remainder === 0) {
          return 'col-md-3 col-md-offset-1'
        } else if (remainder === 2) {
          return 'col-md-4'
        } else {
          return 'col-md-3'
        }
      }
    }
  }

</script>
<style >
.card-image{
  text-align: center;
}
</style>>
